/* Copyright (c) 2018 Verge Technologies
 * @file productCard.js
 * @author Brenton Watt
 * @description Card component for applications for Seperations
 */

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Hashids from 'hashids'

const noImage = require('../../img/no-image.jpg')
const hashids = new Hashids();

const ProductCard = (props) => {
  return (
    <li>
      <div className="image-block">
        {props.product.image_urls.length > 0 && 
        <Link className="image" to={`/product/${props.product.slug}`}>
          <img src={props.product.image_urls[0]} alt="product" />
        </Link>}
        {props.product.image_urls.length === 0 && 
        <Link className="image" to={`/product/${props.product.slug}`}>
          <img src={noImage} alt="product" />
        </Link>}
        <a
          className="favorites"
          onClick={(e) => {
            props.favouriteItem(e, props.product.hash_id);
          }}
        >
          <svg viewBox="0 0 26.81 23.078">
            <g transform="translate(0 0.068)">
              <path
                fill="none"
                stroke="#ffffff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5px"
                d="M23.05,9.94a9,9,0,0,0,.4-2.57C23.45-.3,14-1.14,12.1,4,10.22-1.11.75-.35.75,7.37c0,3.85,2.89,9,11.35,14.19,1.28-.79,2.43-1.58,3.47-2.36"
              />
              <line
                fill="none"
                stroke="#ffffff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.7px"
                y2="12.22"
                transform="translate(19.86 9.94)"
              />
              <line
                fill="none"
                stroke="#ffffff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.7px"
                x2="12.21"
                transform="translate(13.75 16.05)"
              />
            </g>
          </svg>
        </a>
      </div>
      <div className="details-block" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        <Link className="name" to={`/product/${props.product.slug}`} >
          {props.product.name}
        </Link>
        <p>
          by &nbsp;
          <a 
            target="_blank"
            href={`/products?brands#${hashids.encode([props.product.short_id_brand])}`}
          >{props.product.brand}</a>
        </p>
      </div>
    </li>
  );
};

ProductCard.propTypes = {
  updateBrand: PropTypes.func.isRequired,
  product: PropTypes.shape().isRequired,
};

export default ProductCard;



// WEBPACK FOOTER //
// ./src/components/ProductCard/productCard.js